export function envEvaluation(): boolean {
  const environment = process.env.VUE_APP_SENTRY_ENV || 'development';
  const sentyActive = process.env.VUE_APP_SENTRY_ACTIVE || 'no';
  if ((environment === 'production' || environment === 'staging') && sentyActive === 'yes') {
    return true;
  }
  return false;
}
